<template>
<div class="wrapper" style="text-align: left;">
    <div id="container">
<h1>Contact</h1>

    <p>Found a bug? Have a feature request? Wanna give feedback? Feel free to get in touch:</p>

<form class="vue-form" action="https://formspree.io/f/mqknzzpr" method="post">

    <div style="display: flex; flex-direction: column;">
        <div id="name-container" class="container">
            <label for="name-input">Name</label>
            <input type="text" name="name-input" id="name-input">
        </div>
        <div id="email-container" class="container">
            <label for="email-input">Email address</label>
            <input type="text" name="email-input" id="email-input">
        </div>
        <div id="message-container" class="container">
            <label for="message-input">Your message</label>
            <textarea rows="10"  name="message-input" id="message-input" />
        </div>
        <div id="button-container">
            <input 
                type="submit" 
                id="send-button"
                class="button-large"
                value="Send"
            >
        </div>
    </div>

</form>

</div>
</div>
</template>

<style scoped>
#container {
  overflow-y: auto;
  overflow-x: none;

  height: -webkit-fit-content;
  height: -moz-fit-content;

  border-radius: 16px;

  padding-bottom: 2.75rem;
  height: 100vh;
}

h1 {
    margin: 0px 0px 1rem 0px;
}

p, h1, h2, h3 {
    color: var(--background-color);
}

label {
    font-size: .875rem;
}

.container {
    display: flex; 
    flex-direction: column; 
    max-width: 75vw;
    margin-top: 1rem;
}

#button-container {
    max-width: 75vw;
    display: flex;
    justify-content: end;
}

input, textarea {
    border-radius: 0.375rem;
    border: 0 solid #e2e8f0;
    line-height: 2;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    margin-top: 0.25rem;
}

#send-button {
    text-transform: uppercase;
    margin-left: 1rem;
    border: 0px;
    border-radius: 10px;
    padding: 5px 10px;
}

/*
#send-button {
    font-size: 1rem;
    border-radius: 16px;
    height: 50px;
    margin-top: 1rem;
    text-transform: uppercase;
    letter-spacing: 1.76px;
    padding-left: 20px;
    padding-right: 20px;
    font-weight: 700;
    color: var(--btn-color);
    border: 0.15rem solid var(--background-color);
    background-color: var(--background-color);
}
*/

#send-button:hover {
    border: 0.15rem solid white;
    background-color: var(--background-color-hover);
}

#send-button:active {
    border: 0.15rem solid white;
    background-color: var(--background-color-active);
}
</style>